import { defineComponent as _defineComponent } from 'vue'
import moment from "moment";
import { ref, watch, onUpdated } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'commonDate',
  props: {
    modelValue: { type: null, required: true },
    name: { type: String, required: true },
    propname: { type: String, required: false },
    placeholder: { type: String, default: "" },
    v$: Object,
    manualInput: { type: Boolean, default: true },
    autocomplete: { type: String, default: "off" },
    dateFormat: { type: String, default: "MM/DD/YYYY" },
    disabled: { type: Boolean, default: false },
    showIcon: { type: Boolean, default: true },
    minDate: { type: Date, default: null },
    maxDate: { type: Date, default: null },
    selectionMode: { type: String, default: "single" },
    showButtonBar: { type: Boolean, default: true },
    view: { type: String, default: "date" },
    numberOfMonths: { type: String, default: "1" },
    showWeek: { type: Boolean, default: false },
    dateSelect: { type: Function, default: null },
    timeOnly: { type: Boolean, default: false },
    momentdateFormat: { type: String, default: "DD-MM-YYYY" },
    selectOtherMonths: { type: Boolean, default: true },
    showTime: { type: Boolean, default: false }
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const Props = __props;
const emit = __emit;
const isUpdate = ref(false)

watch(() => Props.modelValue, () => {
    if (!isUpdate.value) {
        if (typeof Props.modelValue != "undefined") {
            if (Props.modelValue) {
                let NewDate = moment(new Date(Props.modelValue), Props.momentdateFormat);
                if (NewDate.isValid()) {
                    emit("update:modelValue", NewDate["_d"]);
                    isUpdate.value = true
                }
            }
        }
    }
    else {
        isUpdate.value = false
    }
}
);
const updateValue = (value: any, IsCall: boolean) => {
    let PaidDateCheck = moment(new Date(value), Props.momentdateFormat, true);
    if (PaidDateCheck.isValid()) {
        emit("update:modelValue", PaidDateCheck["_d"]);
        isUpdate.value = true
    }
    else { emit("update:modelValue", undefined); isUpdate.value = false }
    // emit("update:modelValue", value);
    if (Props.dateSelect)
        Props.dateSelect(value);
};

const __returned__ = { Props, emit, isUpdate, updateValue }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})